import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	released: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	unreleased: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	createNewItem: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	released: {
		id: 'issue-field-versions.released',
		defaultMessage: 'Released',
		description: 'released versions',
	},
	unreleased: {
		id: 'issue-field-versions.unreleased',
		defaultMessage: 'Unreleased',
		description: 'unreleased versions',
	},
	createNewItem: {
		id: 'issue-field-versions.create-new-item',
		defaultMessage: 'Create new version',
		description: 'Label for the create new version button',
	},
});

export default messages;
